import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FieldType } from '@ngx-formly/core';
import { MessageService } from '@shared/services/message.service';
import { EditorDialogComponent } from '@shared/components/dialogs/editor-dialog/editor-dialog.component';
import { GuidanceNotesEditorDialogComponent } from '@shared/components/dialogs/guidance-notes-editor-dialog/guidance-notes-editor-dialog.component';
import { GuidanceNote } from '@app/shared/models/guidanceNote';
@Component({
  selector: 'db-custom-field-radio',
  templateUrl: './custom-field-radio.component.html',
  styleUrls: ['./custom-field-radio.component.scss']
})
export class CustomFieldRadioComponent extends FieldType {
  customFieldRadioDialogRef: MatDialogRef<EditorDialogComponent>;
  customFieldRadioDialogRefGN: MatDialogRef<GuidanceNotesEditorDialogComponent>;
  private guidanceNote = new GuidanceNote();

  constructor(
    private messageService: MessageService,
    private dialog: MatDialog,
  ) {
    super();
  }

  editField(f) {
    this.messageService.sendMessage(f.id);
    return false;
  }

  deleteField(field) {
    this.messageService.sendMessage('delete:' + field.id);
    return false;

  }

  openCustomFieldRadioDialog() {
    this.customFieldRadioDialogRef = this.dialog.open(EditorDialogComponent, {
      panelClass: 'db-dialog',
      data: {
        formControl: this.formControl,
        field: this.field
      }
    });
  }

  editGuidanceNotesWindow() {
    this.customFieldRadioDialogRefGN = this.dialog.open(GuidanceNotesEditorDialogComponent, {
      panelClass: 'db-dialog',
      data: {
        guidanceNote: this.guidanceNote
      }
    });
  }
}
